(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"] && !Shopify.designMode) return;
  try {
    
	if(enable_minmax_buys){
		_checkCartPageQuantities(mins, maxs);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function () {

/* ── Search overlay ── */
var searchTrigger = document.querySelector('.wc-search-trigger');
var searchOverlay = document.getElementById('wc-search-overlay');
var searchCloseBtn = searchOverlay ? searchOverlay.querySelector('.wc-search-close-btn') : null;
var searchInput = document.getElementById('wc-search-input');

function openSearch() {
if (!searchOverlay) return;
searchOverlay.classList.add('open');
searchOverlay.setAttribute('aria-hidden', 'false');
if (searchInput) { setTimeout(function () { searchInput.focus(); }, 50); }
}
function closeSearch() {
if (!searchOverlay) return;
searchOverlay.classList.remove('open');
searchOverlay.setAttribute('aria-hidden', 'true');
}

if (searchTrigger) { searchTrigger.addEventListener('click', openSearch); }
if (searchCloseBtn) { searchCloseBtn.addEventListener('click', closeSearch); }

/* ── Mobile drawer ── */
var hamburger = document.querySelector('.wc-hamburger');
var drawer = document.getElementById('wc-mobile-drawer');
var overlay = document.getElementById('wc-mobile-overlay');
var drawerClose = drawer ? drawer.querySelector('.wc-mobile-drawer__close') : null;

function openDrawer() {
if (!drawer) return;
drawer.classList.add('open');
overlay.classList.add('open');
drawer.setAttribute('aria-hidden', 'false');
overlay.setAttribute('aria-hidden', 'false');
hamburger.setAttribute('aria-expanded', 'true');
document.body.style.overflow = 'hidden';
}
function closeDrawer() {
if (!drawer) return;
drawer.classList.remove('open');
overlay.classList.remove('open');
drawer.setAttribute('aria-hidden', 'true');
overlay.setAttribute('aria-hidden', 'true');
if (hamburger) { hamburger.setAttribute('aria-expanded', 'false'); }
document.body.style.overflow = '';
}

if (hamburger) { hamburger.addEventListener('click', openDrawer); }
if (drawerClose) { drawerClose.addEventListener('click', closeDrawer); }
if (overlay) { overlay.addEventListener('click', closeDrawer); }

/* ── Mobile accordion submenus ── */
var mobToggles = document.querySelectorAll('.wc-mob-nav__toggle');
mobToggles.forEach(function (btn) {
btn.addEventListener('click', function () {
var item = btn.closest('.wc-mob-nav__item');
if (item) { item.classList.toggle('expanded'); }
});
});

/* ── Escape key ── */
document.addEventListener('keydown', function (e) {
if (e.key === 'Escape') {
closeSearch();
closeDrawer();
}
});

/* ── Pin header: slide in from top once original scrolls away ── */
var pinnedHeader = document.querySelector('.wc-header');
var headerWrap = pinnedHeader ? pinnedHeader.parentElement : null;
var pinned = false;

function updateHeaderPin() {
    if (!pinnedHeader) return;
    var threshold = pinnedHeader.offsetHeight;
    if (window.scrollY > threshold) {
        if (!pinned) {
            pinned = true;
            /* Reserve the vacated space so page doesn't jump */
            if (headerWrap) headerWrap.style.minHeight = threshold + 'px';
            pinnedHeader.classList.add('is-pinned');
        }
    } else {
        if (pinned) {
            pinned = false;
            pinnedHeader.classList.remove('is-pinned');
            if (headerWrap) headerWrap.style.minHeight = '';
        }
    }
}
window.addEventListener('scroll', updateHeaderPin, { passive: true });
updateHeaderPin();

/* ── Mega menu column hover (existing behaviour) ── */
var mmLinks = document.querySelectorAll('.megamenu__links li a');
mmLinks.forEach(function (el) {
el.addEventListener('mouseover', function () {
var thisIndex = el.dataset.index;
var mega = el.closest('.megamenu');
if (!mega) return;
mega.querySelectorAll('.megamenu li.active').forEach(function (a) { a.classList.remove('active'); });
mega.querySelectorAll('.megamenu li[data-index="' + thisIndex + '"]').forEach(function (a) { a.classList.add('active'); });
});
});

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-cross-sell"] && !Shopify.designMode) return;
  try {
    
    var loadProductRecommendationsIntoSection = function() {
        // Look for an element with class 'product-recommendations'
        var productRecommendationsSection = document.querySelector(".product-cross-sells");

        if (productRecommendationsSection === null) { return; }


        // Build request URL
        var requestUrl = productRecommendationsSection.dataset.url;

        // Create request and submit it using Ajax
        var request = new XMLHttpRequest();

        request.open("GET", requestUrl);

        request.onload = function() {
            if (request.status >= 200 && request.status < 300 && request.response !== "") {
                var container = document.createElement("div");
                container.innerHTML = request.response;

                productRecommendationsSection.innerHTML = container.querySelector(".product-cross-sells").innerHTML;

                if(document.querySelector(".product-cross-sells").textContent.trim() === ""){
                    document.querySelector(".product-cross-sells").closest('section').remove();
                } else {
                    window.initSlider(document.querySelector('.cross-sell-slider'), 1, 'section');
                    window.globalQuickView();
                }

            }else{
                window.initSlider(document.querySelector('.cross-sell-slider'), 1, 'section');
            }
        };

        request.send();
    };
    // If your section has theme settings, the theme editor
    // reloads the section as you edit those settings. When that happens, the
    // recommendations need to be fetched again.
    // See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
    document.addEventListener("shopify:section:load", function(event) {
        if (event.detail.sectionId === "product-cross-sell") {
            loadProductRecommendationsIntoSection();
        }
    });

    // Fetching the recommendations on page load
    loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
    var loadProductRecommendationsIntoSection = function() {
        // Look for an element with class 'product-recommendations'
        var productRecommendationsSection = document.querySelector(".product-recommendations");

        if (productRecommendationsSection === null) { return; }


        // Build request URL
        var requestUrl = productRecommendationsSection.dataset.url;

        // Create request and submit it using Ajax
        var request = new XMLHttpRequest();

        request.open("GET", requestUrl);

        request.onload = function() {
            if (request.status >= 200 && request.status < 300) {
                var container = document.createElement("div");
                container.innerHTML = request.response;

                var fetched = container.querySelector(".product-recommendations");

                // A new store has no recommendation data yet, so the API can come
                // back with no products. Keep the server-rendered fallback rather
                // than replacing it with an empty section.
                if (!fetched || fetched.querySelectorAll(".product-tile").length === 0) { return; }

                productRecommendationsSection.innerHTML = fetched.innerHTML;

                initRelatedSlider();

                window.globalQuickView();
            }
        };

        request.send();
    };

    // Used for both the fallback rendered with the page and the fetched recommendations.
    var initRelatedSlider = function() {
        var slider = document.querySelector('.related-slider');

        if (slider && !slider.classList.contains('swiper-initialized')) {
            window.initSlider(slider, 1, 'section');
        }
    };
    // If your section has theme settings, the theme editor
    // reloads the section as you edit those settings. When that happens, the
    // recommendations need to be fetched again.
    // See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
    document.addEventListener("shopify:section:load", function(event) {
        if (event.detail.sectionId === "product-recommendations") {
            loadProductRecommendationsIntoSection();
        }
    });

    // The fallback ships with the page, so its slider needs starting up front.
    initRelatedSlider();

    // Fetching the recommendations on page load
    loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
